import React from 'react';

export const Chip: React.FC<{
    label: string;
    icon?: React.ReactNode;
    onEdit?: () => void;
}> = ({ label, icon, onEdit }) => (
    <span className="inline-flex items-center gap-1 rounded-xl bg-gray-100 px-3 py-1 text-xs text-gray-700 ring-1 ring-gray-200">
        {icon && <span className="text-gray-500">{icon}</span>}
        {label}
        {onEdit && (
            <button onClick={onEdit} className="ml-1 rounded p-0.5 text-gray-400 hover:bg-gray-200 hover:text-gray-700">
                ✎
            </button>
        )}
    </span>
);
